import type { OmniNavItem, OmniNavSection } from './types';
import { GROUP_LIMIT } from './types';

function flattenSections(sections: OmniNavSection[]): OmniNavItem[] {
  const seen = new Set<string>();
  const out: OmniNavItem[] = [];
  for (const section of sections) {
    for (const item of section.items) {
      if (seen.has(item.key)) continue;
      seen.add(item.key);
      out.push(item);
    }
  }
  return out;
}

/** Match pages for global search: label, section label, hint, path. */
export function matchNav(
  sections: OmniNavSection[],
  query: string,
  limit = GROUP_LIMIT
): OmniNavItem[] {
  const flat = flattenSections(sections);
  const q = query.trim().toLowerCase();
  if (!q) return flat.slice(0, limit);

  const matched: OmniNavItem[] = [];
  for (const section of sections) {
    const sectionLabel = section.label?.toLowerCase() ?? '';
    for (const item of section.items) {
      if (matched.some((m) => m.key === item.key)) continue;
      const haystack = [
        item.label,
        sectionLabel,
        item.hint ?? '',
        item.path,
      ]
        .join(' ')
        .toLowerCase();
      if (haystack.includes(q)) matched.push(item);
      if (matched.length >= limit) return matched;
    }
  }
  return matched;
}
